import { zReferralBonusShare } from '@/general/src/agent/utils.shared.js'
import { zAgentPermission } from '@/general/src/auth/can.js'
import { zPhoneOptionalNullable } from '@/general/src/other/phone.js'
import { zEmailRequired, zSNOptionalNullable, zStringOptionalNullable } from '@/general/src/other/validation.js'
import { zAgentSubscriptionPlan } from '@/general/src/subscription/utils.shared.js'
import { z } from 'zod'

export const zCreateAgentInput = z.object({
  organizationSn: zSNOptionalNullable,
  email: zEmailRequired,
  phone: zPhoneOptionalNullable,
  name: zStringOptionalNullable,
  permissions: zAgentPermission.array(),
  referrerAgentSn: zSNOptionalNullable,
  referralBonusShare: zReferralBonusShare,
  subscriptionPlan: zAgentSubscriptionPlan,
  paidSubscriptionPlanExpiresAfterDays: z.coerce.number().int().min(1).max(31),
  temporaryRecognitionTokensCount: z.coerce.number().int().min(1).max(3000),
  temporaryScenarioTokensCount: z.coerce.number().int().min(1).max(3000),
})
